import { render, staticRenderFns } from "./Dark.vue?vue&type=template&id=81f0fba4&scoped=true&"
import script from "./Dark.vue?vue&type=script&lang=js&"
export * from "./Dark.vue?vue&type=script&lang=js&"
import style0 from "./Dark.vue?vue&type=style&index=0&id=81f0fba4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f0fba4",
  null
  
)

export default component.exports